module.exports = __webpack_public_path__ + "img/max9.23536ca2.jpg";